import React, {Component} from 'react';
import PropTypes from 'prop-types';
import OptionRange from '../../components/fileLibrary/option/OptionRange'
import FileLibrary from '../../components/fileLibrary/FileLibrary'
import BaseComponent from '../../../../base/BaseComponent'
import {AUDIO_TYPE, HEADER_HEIGHT, LOGO_HEIGHT, PIC_TYPE, VIDEO_TYPE} from '../../../../constants';
import {Button, Empty, Popover, Input, Timeline,Icon} from "antd";
import Pattern from "../../components/Pattern";
import {Scrollbars} from "react-custom-scrollbars";
import {formatTime, resourceFormatDate, uuid} from "../../../../utils";
import TableList from "../../components/resourcePool/Table";
import Detailpage from "../../components/DetailPage";
import {uploadType} from '../../components/resourcePool/uploadSetting'
import {message} from "../../components/Mess";
import UploadStatus from "../../components/UploadStatus";
import {optionConfig} from "./option-config";
import {
    changeLoginStatus,
    loadSystemConfigList,
    loadCurrentUser,
    loadNavigateData,
    updataNavigateData,
    shrinNavigateStauts,
    updateNavigateLevel2Data, changeNavigateStauts
} from "../../../../actions";
import {connect} from "react-redux";
import $ from "jquery";
const {Search} = Input;


 class ComposeFile extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            authType: '',
            indexName: '',
            params: {
                pageNum: 1,
                pageSize: 40,
            },
            commonFiles: [],
            md5: '',
            selectType: false,//大 中 小  名称  时间  日期模式的按钮
            btnNames: ["MyUpload", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel"],
            checkArray: [],//选中的数据
            checkedStatus:'card',
            keyword: '',//搜索的字段
            uploadStatus:1,
            // fileList:[],
            newData:[],
            count:'',
            selectedRowKeys:[]
        }
    }

    componentWillMount() {
        const {authType, indexName} = this.props.match.params;
        this.getBtn(authType,indexName)
    }

    componentDidUpdate(prevProps) {
        if ((this.props.match.params.authType!== prevProps.match.params.authType) || (this.props.match.params.indexName !== prevProps.match.params.indexName)) {
            let authType = this.props.match.params.authType;
            let indexName = this.props.match.params.indexName;
            this.getBtn(authType,indexName);
            this.state.commonFiles = [];
            this.state.checkArray=[];
            this.state.checkedStatus='card';
            this.state.params.pageNum=1;
            this.state.params.pageSize =40;
            this.Fallback();
            this.getData();
            this.empty();
        }
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if ((parseInt(this.state.authType) !== nextProps.match.params.authType) || (parseInt(this.state.indexName) !== nextProps.match.params.indexName)) {
    //        let authType = nextProps.match.params.authType;
    //         let indexName = nextProps.match.params.indexName;
    //         this.getBtn(authType,indexName);
    //         this.state.commonFiles = [];
    //         this.state.checkArray=[];
    //         this.state.checkedStatus='card';
    //         this.state.params.pageNum=1;
    //         this.state.params.pageSize =40;
    //         this.Fallback();
    //         this.getData()
    //         this.empty()
    //     }
    // }
     Fallback=()=>{
         //处理菜单 回退前进的问题
         let currentUrl=window.top.location.hash;
         currentUrl=currentUrl.replace('#','');
         let {stopFind, sons, name} = this.findUrlData(currentUrl);
         if (stopFind) {
             this.props.shrinNavigateStauts();
             this.props.navigateData.forEach(item => {
                 if (item.menuName === name) {
                     item.check = true;
                     item.status = "down";
                     if(item.child&&item.child.length){
                         this.upLoadSecondaryMenu(item.child,currentUrl)
                     }
                 } else {
                     item.check = false;
                     item.status = "up"
                 }
             });
             this.props.updateNavigateLevel2Data(name, sons);
             // console.log(this.props.navigateData);
             this.props.updataNavigateData(this.props.navigateData);
         }
     };

     upLoadSecondaryMenu(data,currentUrl){
         data.forEach((item,index)=>{
             if (item.path === currentUrl) {
                 item.check = true;
                 item.status = "down";
             } else {
                 item.check = false;
                 item.status = "up"
             }
             if (item.path !== currentUrl&&item.child){
                 this.upLoadSecondaryMenu(item.child,currentUrl)
             }
         });
     }
    componentDidMount() {
        this.getData()
    }
    getBtn=(authType,indexName)=>{
        this.state.authType = authType;
        this.state.indexName = indexName;
        uploadType&&uploadType.length&&uploadType.forEach((item=>{
            if(item.name === indexName){
                this.state.uploadStatus =item.type
            }
        }));
        if(authType==='public'){
            this.state.btnNames =["Partake", "DownLoad", "AskFor"]
        }else{
            this.state.btnNames= ["MyUpload", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel"]
        }
        let parms ={};
        parms.pageNum =1;
        parms.pageSize =40;
        this.state.params = parms;
        this.state.key =uuid();
        // this.state.fileList=[];
        this.state.keyword ='';
        this.setState({},()=>{

        });

    };

    getData = () => {
        const {indexName, authType, params} = this.state;
        this.request({
            url: `/search-server/search/getList/${indexName}/${authType}`,
            method: "POST",
            body: params,
            loading:true,
            contentType: 'json',
            callBack: (res) => {
                this.state.count = res.count;
                if (res && res.data&&res.data.length) {

                    res.data.forEach((item) => {
                        item.fileTypeEnum = 'FILE'
                    });
                    if(this.state.checkedStatus==='list'){
                        this.state.commonFiles =  res.data
                    }else{
                        if (this.state.params.pageNum > 1) {
                            this.state.commonFiles = [...this.state.commonFiles, ...res.data];
                        } else {
                            this.state.commonFiles =  res.data
                        }
                    }
                }else{
                    this.state.commonFiles =  []
                }
                this.setState({},()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                });

            },
            errorCallBack: (e) => {
                this.setState({commonFiles: []});
            },
            serverVerify: {
                serverErrorCallBack: (e) => {
                    console.log(e)
                }
            }

        });
    };

     empty(){
         this.state.checkArray && this.state.checkArray.length && this.state.checkArray.forEach((item, index) => {
             item.checked = false
         });
         this.state.checkArray = [];
         this.state.selectedRowKeys= [];
         this.setState({},()=>{
             $('.ant-pagination-options-quick-jumper').find('input').val('')
         });
     }


    //下载图片
    downloadPic(md5,item){
        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
            method: "post",
            body:{
                virtualFileId:item.id,
                name:item.name,
                downloadFlag:false
            },
            contentType:'json',
            callBack: (data) => {
                if(data){
                    let url =  "/storage/downloadFile?md5="+md5+'&download=1'+'&name='+item.name;
                    let aObj = document.createElement('a');
                    aObj.setAttribute('download','');
                    aObj.setAttribute('href',url);
                    aObj.click();
                    aObj = null
                    let fileType = '';
                    if(PIC_TYPE.indexOf(item.suffix)>-1) {
                        fileType = 1;
                    }else if(VIDEO_TYPE.indexOf(item.suffix)>-1){
                        fileType = 2;
                    }else if(AUDIO_TYPE.indexOf(item.suffix)>-1){
                        fileType = 3;
                    }else {
                        fileType = 4;
                    }
                    let body = {
                        id:item.id,
                        fileName:item.name,   //String 文件名称
                        fileIcon:item.icon,   //String 文件显示缩略图
                        type:fileType,        //Integer 文件类型 参考前面保持一致
                        md5:data.md5,         //String 文件的md5
                        size:item.size,        //long  文件大小
                    }
                    this.request({
                        url: "/cm-sites-storage-management/zykStatistics/addDownloadRecords",
                        method: "post",
                        body:body,
                        contentType:'json',
                    })
                }
            }
        });
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 32 ;
        return (
            <div style={{padding: '0 15px', margin: "15px 0 15px 15px", background: '#ffffff', borderRadius:5,maxHeight:"calc(100vh - 100px)",   position: 'relative', paddingBottom: "15px", }} key={this.state.key}>
                {this.renderSelect()}
                {this.renderBtn()}
                {this.renderCommonFiles()}
                {/*{this.renderUploding()}*/}
                {this.state.checkedStatus!='list'?this.renderNextPage():null}
            </div>
        )
    }
    /*监听滚动*/
    onScroll = e => {
        if (e.target.scrollTop + e.target.clientHeight  >= e.target.scrollHeight) {
            if (this.state.count > this.state.params.pageNum * this.state.params.pageSize) {
                this.state.params.pageNum = this.state.params.pageNum + 1;
                this.getData()
            }
        }
    };
    renderUploding() {
        return(<UploadStatus fileList={this.state.fileList}   cancelUpload={this.cancelUpload} callBack={(fileList)=>{
            this.setState({fileList},()=>{
            })
        }}></UploadStatus>)
    }
     //取消上传
     cancelUpload=(file)=>{
         console.log(this.MyUpload)
         this.MyUpload.cancelUpload(file)
     };
    renderBtn() {
        let width = document.body.clientWidth ;

        let {btnNames,params}=this.state;

        return (
            <div style={{display:width>1366? 'flex':'block', paddingTop: 24, justifyContent: 'space-between',}}>
                <div style={{display: 'flex',width:width>1366? '60%':'100%',height:'30px'}}>
                    {
                        btnNames && btnNames.length > 0 && btnNames.map((item, index) => {
                            let ItemComponent = require(`../../components/${item}.js`);
                            let ItemComponentDefault = ItemComponent.default;
                            return <ItemComponentDefault key={index}
                                                         ref={(ref) => {
                                                             this[item] = ref
                                                         }}
                                                         checkArray={this.state.checkArray}
                                                         UpLoadType={this.state.uploadStatus}
                                                         IsTile={true}
                                                         currentId={this.state.currentId}
                                                         resourceName={this.state.authType}
                                                         uplodCallBack={(fileList)=>{
                                                                 // this.setState({fileList});

                                                          }}
                                                             callBack={()=>{
                                                                 this.getData()
                                                                 this.empty()
                                                                 // setTimeout(()=>{
                                                                 //
                                                                 // },1000)
                              }}
                            />;
                        })
                    }

                    <Search
                        allowClear
                        placeholder="请输入关键字"
                        onSearch={(value) => {
                            if(value){
                                params.keyword= value;
                            }else {
                                delete params.keyword
                            }
                            this.state.params.pageNum=1;
                            this.setState({},()=>{
                                this.getData()
                                this.empty()
                            })
                        }}
                        style={{width: 224, height: '32px',marginLeft:19}}

                    />
                </div>
                <div>
                    <Pattern
                        dataSource={this.state.commonFiles}
                        count={this.state.count}
                        isAll={true}
                        IsShow={true}
                        Subdirectory={this.props.Subdirectory}
                        callBack={(type, currentItem) => {
                           this.SwitchingMode( type, currentItem)
                        }}
                    ></Pattern>
                </div>

            </div>
        )
    }


    refreshList(){
     //如果是列表模式  返回到上一页
     if(this.state.checkedStatus==='list'){
       let count = this.state.count;
       let size = this.state.params.pageSize;
       let page = this.state.params.pageNum;
        let pageSum =Math.ceil( count/size);
        let dataLength = this.state.commonFiles.length-this.state.checkArray.length;
            if(dataLength === 0){
                if(pageSum == page){	//最后一页
                    page = page > 1 ? page-1 : 1
                }else{
                    page = page
                }
            }
            this.setState({selectedRowKeys:[]},()=>{
                this.onChangePage(page,this.state.params.pageSize)
            });

    }else{
         //如果是卡片模式或者时间轴模式
            this.state.params.pageNum =1;
            this.setState({},()=>{
                this.getData();
                this.empty()
                // this.scrollRef.scrollTop(0)
                 })
     }
    }
    //切换模式
    SwitchingMode(type, currentItem){
         this.state.checkedStatus=currentItem.type;
         this.state.params.pageNum = 1;
         this.state.checkArray = [];
        this.state.commonFiles =[];
        if( this.state.checkedStatus==='list'){
            this.state.params.pageSize =10
        }else{
            this.state.params.pageSize =40
        }
        this.setState({}, () => {
            this.getData()
            this.empty()
        })
    }

    //卡片模式
    Card=()=>{
        return(
            <div style={{display:'grid',
                justifyContent: 'space-between',
                padding:'0px 10px 0px 0px',
                gridTemplateColumns:' repeat(auto-fill, 180px)',
            }}>
                {
                    this.state.commonFiles.map((item, index) => {
                        return (
                            <div key={item.id} style={{marginBottom:'20px'}} >
                                <FileLibrary file={item}
                                             IsDownLoad={item.extendedAttributeJson&&item.extendedAttributeJson.download?item.extendedAttributeJson.download:false}
                                             configName={this.state.indexName}
                                             onDownloadCall={(md5) => {
                                                 this.downLoad(md5,item)
                                             }}
                                             applyDownload={()=>{
                                                 message.error('您没有所选资源的使用权限，请申请下载！')
                                             }}
                                             onClick={()=>{
                                                 this.itemClick(item,index)
                                             }}
                                             checked={item.checked}
                                             IsChecked={(e) => this.IsCheck(e, item)}
                                />
                            </div>
                        )
                    })}
            </div>
        )
    };
    // 表格模式
    Table=()=>{
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.checkArray = selectedRows;
                this.setState({checkArray:selectedRows}, () => {
                })

            },
        };
        return(
            <TableList rowKey="id" Btn={[]}
                       checkArray={this.state.checkArray}
                       count={this.state.count}
                       btnNames={this.state.btnNames}
                       page={this.state.params.pageNum}
                       size={ this.state.params.pageSize}
                       onChangePage={(page, size)=>{
                           this.onChangePage(page, size)
                       }}
                       IsTile={true}
                       resourceName={this.state.authType}
                       currentId={this.state.currentId}
                       onClick={(record) => {
                           this.itemClick(record, -1)
                       }}
                        rowSelection={rowSelection}
                        callBack={() => {

                               if (this.state.commonFiles.length === 1) {
                                   this.onChangePage(this.state.params.pageNum - 1, this.state.params.pageSize)
                               } else {
                                   this.onChangePage(this.state.params.pageNum, this.state.params.pageSize)
                               }
                       }}
                       dataSource={this.state.commonFiles}
            ></TableList>
        )
    };

    getSelectedRowKeys = () => {
        let selectedRowKeys = [];
        for (let j = 0; this.state.checkArray && j < this.state.checkArray.length; j++) {
            let row = this.state.checkArray[j];
            selectedRowKeys.push(row.id);
        }
        return selectedRowKeys;
    };

    onChangePage(page, size) {
        this.state.params.pageNum = page;
        this.state.params.pageSize = size;
        this.setState({}, () => {
            this.getData()
            this.empty()
        })
    }


    //时光轴模式
    Timeline=()=>{
        let dataInfo = {};
        this.state.commonFiles.forEach((item, index) => {
            let createTime = resourceFormatDate(item.createTime);

            if (!dataInfo[createTime]) {
                dataInfo[createTime] = {
                    createTime,
                    child: []
                }
            }
            dataInfo[createTime].child.push(item);
        });
        let list = Object.values(dataInfo); // list 转换成功的数据
        return(
            <div >
                {list.map((Item, index) => {
                    return (
                        <Timeline.Item key={index} style={{width: '100%'}} >
                            <div style={{cursor: 'pointer'}}
                            >{Item.createTime}</div>
                            <div style={{display: 'flex', marginTop: 20,}}>
                                <div style={{width: '100%',display:'grid',
                                    justifyContent: 'space-between',
                                    padding:'0px 10px 0px 0px',
                                    gridTemplateColumns:' repeat(auto-fill, 180px)',}}>{
                                    Item.child && Item.child.map((item, index) => {
                                        return (
                                            <div key={item.id} style={{}}>
                                                <FileLibrary file={item}
                                                             IsDownLoad={item.extendedAttributeJson&&item.extendedAttributeJson.download?item.extendedAttributeJson.download:false}
                                                             configName={this.state.indexName}
                                                             onDownloadCall={(md5) => {
                                                                 this.downLoad(md5,item)
                                                             }}
                                                             applyDownload={()=>{
                                                                 message.error('您没有所选资源的使用权限，请申请下载！')
                                                             }}
                                                             onClick={()=>{
                                                                 this.itemClick(item,index)
                                                             }}
                                                             checked={item.checked}
                                                             IsChecked={(e) => this.IsCheck(e, item,)}
                                                />
                                            </div>
                                        )
                                    })
                                }
                                </div>
                            </div>
                        </Timeline.Item>
                    )
                })}
            </div>
        )
    };

    //下拉菜单
    renderSelect() {
        let newOptionConfig = optionConfig
        try {
            let zyk = this.sysConfigGetValueByKey("zyk_screen_optionConfig", "")
            newOptionConfig = JSON.parse(zyk)
        } catch (e) {
            console.log(e.toString())
        }
        let configs = newOptionConfig[this.state.authType] && newOptionConfig[this.state.authType][this.state.indexName] || [];

        return (
            <div style={{height: '48px', borderBottom: '1px solid rgba(0, 0, 0, 0.15)', lineHeight: '55px'}}
                 key={this.state.key} >
              <OptionRange
                    configs={configs}
                    configName={this.state.indexName}
                    onClickCall={(data) => {
                         this.changeStatus(data)
                    }}/>
           </div>
        )
    };
    //切换上面的选择
    changeStatus(config){
        let {params} = this.state;
        let flag = false;
        if(config && config.length) {
            config.forEach(item=>{
                if(item.data.toString().indexOf('不限')>-1){
                    if(params[item.type] != undefined) {
                        flag = true;
                    };
                    delete params[item.type]
                }else{
                    if (item.data || item.data === 0) {
                        if(params[item.type] != item.data) {
                            flag = true;
                        };
                        params[item.type] = item.data;
                    } else {
                        if(params[item.type] != undefined) {
                            flag = true;
                        };
                        delete params[item.type]
                    }
                }
            })
        }
        if(flag) {

            this.state.params.pageNum=1;
            this.scrollRef && this.scrollRef.scrollToTop();
            this.setState({},()=>{
                this.getData()
                this.empty()
            }

            )
        }
    }

    //图片视频音频其他
    renderCommonFiles() {
        let {commonFiles,checkedStatus} = this.state;
        let tableHeight = document.body.clientHeight - HEADER_HEIGHT - 30 - 180;
        return (
            <div style={{marginTop: this.state.checkedStatus!='list'?24:0}}>
                {
                    commonFiles && commonFiles.length ?<div >
                        {checkedStatus==='list'?this.Table(): <Scrollbars
                            autoHeight
                            autoHide
                            autoHeightMax={tableHeight}
                            ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}
                            onScroll={this.onScroll.bind(this)}
                        >
                            {checkedStatus==='timeAxis' ? this.Timeline(): this.Card()}
                        </Scrollbars>
                        }

                    </div>: <Empty/>
                }
                <Detailpage  key={this.state.modalKey} onRef={ref => this.setDetailpage = ref} onCloseCall={()=>{
                    // this.state.params.pageNum=1;
                    // this.state.params.pageSize =40;
                    // this.state.modalKey = uuid()
                    //
                    // this.setState({},()=>{
                    //     this.getData()
                    // })
                    }}
                     dataList={commonFiles}></Detailpage>
            </div>
        )
    }
    //downLoad  下载
    downLoad(md5,item){
        if(item.extendedAttributeJson&&item.extendedAttributeJson.download){
            message.error('您没有所选资源的使用权限，请申请下载！')
        }else{
            this.downloadPic(md5,item)
        }
    }
    //选中的数据
    IsCheck(e, item) {
        let _this = this;
        item.checked = e;
        if (item.checked) {
            _this.state.checkArray.push(item)
        } else {
            _this.state.checkArray = _this.state.checkArray.filter(Item => Item.id !== item.id)
        }
        _this.setState({}, () => {
        })
    }

    itemClick(item,index){
        let status=item.extendedAttributeJson && item.extendedAttributeJson.download ? item.extendedAttributeJson.download:false


        if(!status){
            this.setDetailpage.show(true, item,index,this.state.btnNames.indexOf('Rename')>-1)
        }else{
            message.error("您没有所选资源的使用权限，请申请下载！")
        }

    }
    renderNextPage(){
        let count = this.state.count;
        let size = this.state.params.pageSize;
        let page = this.state.params.pageNum;
        let pageSum =Math.ceil( count/size);
        return(
            <div style={{height: "60px"}}>
                    <div style={{width:'120px',height:'40px',background:'#ffffff',justifyContent: "center",
                        display: "flex",
                        border: "1px solid #D9D9D9",
                        alignItems: "center",
                        position: "absolute",
                        bottom: '5px',
                        left:'50%',
                        marginLeft:'-60px',
                        zIndex:'999',
                        cursor: 'pointer',
                    }}
                    onClick={()=>{
                        if(pageSum>1&&this.state.checkedStatus!='list'&&page!=pageSum){
                            this.state.params.pageNum = this.state.params.pageNum + 1;
                            this.getData()
                        }

                    }}

                    > {pageSum>1&&this.state.checkedStatus!='list'&&page!=pageSum?
                        <span> <Icon type="loading"  style={{fontSize:'20px',marginRight:5}}/>加载更多</span> :'已加载全部'}
                    </div>
            </div>
        )
    }

    //格式化url
    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.child || data.child.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.child;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.child;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.menuName);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({child: this.props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };

}

function mapStateToProps(state) {
    return {
        navigateStatus: state.systemReducer.navigateStatus,
        currentUser: state.systemReducer.currentUser,
        messageCount: state.systemReducer.messageCount,
        sysConfig: state.systemReducer.config,
        navigateData: state.systemReducer.navigateData,
    }
}
function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        },
        loadSystemConfigList: function (callBack, errorCallBack) {
            return dispatch(loadSystemConfigList(callBack, errorCallBack));
        },
        loadCurrentUser: function (callBack, errorCallBack) {
            return dispatch(loadCurrentUser(callBack, errorCallBack));
        },
        changeLoginStatus: function (systemStatus) {
            return dispatch(changeLoginStatus(systemStatus))
        },
        loadNavigateData: function () {
            return dispatch(loadNavigateData())
        },
        updataNavigateData: function (data) {
            return dispatch(updataNavigateData(data))
        },
        changeNavigateStauts:function () {
            return dispatch(changeNavigateStauts())
        }
    }
};

export default connect(mapStateToProps, mapStateToMethod)(ComposeFile);